module.exports = __webpack_public_path__ + "img/bp02.58dfbd18.jpg";